<template>
    <div class="rkld">
        <div class="rkldRight">
            <div class="rkldRightContent">
                <el-tabs
                    v-model="editableTabsValue"
                    type="card"
                    @edit="handleTabsEdit"
                >
                    <el-tab-pane
                        :key="item.name"
                        v-for="item in editableTabs"
                        :label="item.title"
                        :name="item.name"
                    >
                        <!--查询条件-->
                        <div class="searchTj">
                            <div class="searchTjHead">
                                <span>查询条件</span>
                                <!-- <el-button
                  style="float: right; padding: 3px 0; color: #000"
                  type="text"
                  @click="Reset"
                >
                  <i class="el-icon-refresh"></i>
                  刷新页面
                </el-button> -->
                                <i
                                    class="searchDomw"
                                    @click="searchValue = !searchValue"
                                    :class="
                                        searchValue == true
                                            ? 'el-icon-arrow-up'
                                            : 'el-icon-arrow-down'
                                    "
                                ></i>
                            </div>
                            <el-form
                                :model="form1"
                                class="searchTjContent"
                                v-show="searchValue"
                            >
                                <div
                                    class="searchTjContentDiv"
                                    style="width: 450px"
                                >
                                    <span class="searchTjContentDivSpan"
                                        >开始时间</span
                                    >
                                    <el-date-picker
                                        v-model="dataTime"
                                        type="week"
                                        @change="showDates"
                                        :picker-options="{ firstDayOfWeek: 1 }"
                                        :format="start + '至' + end"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        style="width: 100%"
                                        placeholder="选择周"
                                    >
                                    </el-date-picker>
                                </div>
                                <div
                                    class="searchTjContentDiv"
                                    v-show="quanbu"
                                    v-if="searchValue"
                                >
                                    <el-button
                                        type="primary"
                                        @click.native="query"
                                        size="medium"
                                        class="searchBtns"
                                        icon="el-icon-search"
                                        >查询
                                    </el-button>
                                </div>

                                <!-- <div class="searchTjContentDiv" v-if="searchValue">
                  <el-button type="info" icon="el-icon-delete" @click="resert"
                    >清除条件
                  </el-button>
                </div> -->
                                <!-- <div class="arrowDown" @click="showSearch">
                  <i class="el-icon-arrow-down" style="color: #000"></i>
                </div> -->
                            </el-form>
                        </div>

                        <!--按钮-->
                        <div class="searchButtonDiv" v-if="quanbu">
                            <div class="searchButtonDivLeft">
                                <el-button-group>
                                    <el-button
                                        icon="el-icon-plus"
                                        type="success"
                                        class="openBtns"
                                        @click="showDialog('新增')"
                                        >新增
                                    </el-button>
                                    <el-button
                                        icon="el-icon-delete"
                                        type="danger"
                                        @click="batchDelete"
                                        >批量删除
                                    </el-button>
                                </el-button-group>
                            </div>
                            <div class="searchButtonDiveRight">
                                <el-button-group>
                                    <el-button
                                        type="primary"
                                        icon="el-icon-refresh"
                                        class="dropRests"
                                        @click="resertTable"
                                    ></el-button>
                                    <!-- <el-button type="primary"> -->
                                    <el-dropdown
                                        class="dropdown"
                                        trigger="click"
                                        :hide-on-click="false"
                                    >
                                        <span class="el-dropdown-link">
                                            <i
                                                class="
                                                    el-icon-s-grid
                                                    el-icon--right
                                                "
                                                style="color: #fff"
                                            ></i>
                                            <i
                                                class="
                                                    el-icon-arrow-down
                                                    el-icon--right
                                                "
                                            ></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item>
                                                <template>
                                                    <el-checkbox-group
                                                        v-model="checkList"
                                                        :min="1"
                                                        @change="tableShow"
                                                    >
                                                        <el-checkbox
                                                            label="序号"
                                                            >序号</el-checkbox
                                                        >
                                                        <br />
                                                        <el-checkbox
                                                            label="菜单名称"
                                                            >菜单名称
                                                        </el-checkbox>
                                                        <br />
                                                        <el-checkbox
                                                            label="开始时间"
                                                            >开始时间
                                                        </el-checkbox>
                                                        <br />
                                                        <el-checkbox
                                                            label="结束时间"
                                                            >结束时间
                                                        </el-checkbox>
                                                        <br />
                                                        <el-checkbox
                                                            label="创建时间"
                                                            >创建时间
                                                        </el-checkbox>
                                                        <br />
                                                        <el-checkbox
                                                            label="创建人"
                                                            >创建人</el-checkbox
                                                        >
                                                        <br />
                                                        <el-checkbox
                                                            label="操作"
                                                            >操作</el-checkbox
                                                        >
                                                        <br />
                                                    </el-checkbox-group>
                                                </template>
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                    <!-- </el-button> -->
                                </el-button-group>
                            </div>
                        </div>

                        <!--表格-->
                        <div>
                            <el-table
                                ref="multipleTable"
                                :data="myData"
                                tooltip-effect="dark"
                                @row-click="openDetails"
                                highlight-current-row
                                @selection-change="handleSelectionChange"
                                :header-cell-style="{
                                    background: '#e6e6e6',
                                    color: '#000',
                                }"
                                border
                            >
                                <el-table-column
                                    type="selection"
                                    width="80"
                                    align="center"
                                    @selection-change="handleSelectionChange"
                                >
                                </el-table-column>
                                <el-table-column
                                    type="index"
                                    width="100"
                                    label="序号"
                                    header-align="center"
                                    align="center"
                                    v-if="no1"
                                ></el-table-column>
                                <!-- <el-table-column
                  prop="orgName"
                  label="菜单名称"
                  align="center"
                  width="300"
                  v-if="no2"
                  show-overflow-tooltip
                >
                </el-table-column> -->
                                <el-table-column
                                    prop="startTime"
                                    label="开始时间"
                                    align="center"
                                    show-overflow-tooltip
                                    v-if="no3"
                                    :formatter="formatDate"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="endTime"
                                    label="结束时间"
                                    align="center"
                                    show-overflow-tooltip
                                    v-if="no4"
                                    :formatter="formatDate"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="createTime"
                                    label="创建时间"
                                    align="center"
                                    show-overflow-tooltip
                                    v-if="no5"
                                    :formatter="formatDate"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="name"
                                    label="创建人"
                                    align="center"
                                    show-overflow-tooltip
                                    v-if="no6"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="operation"
                                    label="操作"
                                    align="center"
                                    width="280"
                                    v-if="no7"
                                >
                                    <template slot-scope="scope">
                                        <el-row type="flex" justify="start">
                                            <el-col :span="6">
                                                <el-link
                                                    :underline="false"
                                                    @click="
                                                        showPrint(scope.row)
                                                    "
                                                    >打印
                                                </el-link>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-link
                                                    :underline="false"
                                                    @click="
                                                        showDialog(
                                                            '查看',
                                                            scope.row
                                                        )
                                                    "
                                                    >查看
                                                </el-link>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-link
                                                    :underline="false"
                                                    @click="
                                                        showDialog(
                                                            '编辑',
                                                            scope.row
                                                        )
                                                    "
                                                    >编辑
                                                </el-link>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-link
                                                    :underline="false"
                                                    @click="
                                                        deleteItem(scope.row)
                                                    "
                                                    >删除
                                                </el-link>
                                            </el-col>
                                        </el-row>
                                        <!-- <el-tooltip
                        class="item"
                        effect="dark"
                        content="打印"
                        placement="top-start"
                    >
                        <button
                            style="color: #000"
                            class="iconfont icon-chakan tabBtn"
                            @click="showPrint(scope.row)"
                        ></button>
                    </el-tooltip>
                    <el-tooltip
                        class="item"
                        effect="dark"
                        content="编辑"
                        placement="top-start"
                    >
                        <button
                            style="color: #000"
                            class="iconfont icon-bianji3 tabBtn"
                            @click="
                                showDialog(
                                    '编辑',
                                    scope.row
                                )
                            "
                        ></button>
                    </el-tooltip>
                    <el-tooltip
                        class="item"
                        effect="dark"
                        content="删除"
                        placement="top-start"
                    >
                        <button
                            style="color: #000"
                            class="iconfont icon-icon7 tabBtn"

                        ></button>
                    </el-tooltip> -->
                                    </template>
                                </el-table-column>
                            </el-table>

                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total"
                            ></el-pagination>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <el-dialog
            :title="dialogTile"
            :visible.sync="visVisible"
            width="990px"
            :close-on-click-modal="false"
            @close="clearadddata"
        >
            <el-form
                ref="addform"
                :model="addform"
                :rules="addformRules"
                label-width="110px"
                size="mini"
            >
                <el-form-item label="机构名称：" prop="orgName">
                    <el-input
                        disabled
                        v-model="addform.orgName"
                        placeholder="请输入机构名称"
                    ></el-input>
                </el-form-item>
                <!-- <el-form-item label="菜单名称：" prop="orgName">
          <el-input
            :disabled="dialogTile == '查看'"
            v-model="addform.orgName"
            placeholder="请输入菜单名称"
          ></el-input>
        </el-form-item> -->

                <el-form-item label="开始时间：" prop="startTime">
                    <el-date-picker
                        v-model="addform.startTime"
                        type="week"
                        @change="showDate"
                        :disabled="dialogTile == '编辑' || dialogTile == '查看'"
                        :picker-options="{ firstDayOfWeek: 1 }"
                        :format="start + '至' + end"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 100%"
                        placeholder="选择周"
                    >
                    </el-date-picker>
                </el-form-item>

                <!-- <el-form-item label="组织机构：" style="height:40px">
  <el-select style="width: 100%;"
             class="marginT34"
             v-model="addform.orgName"
             placeholder="请选择组织机构"
             ref="selectBoxRef"
             >
    <el-option :value="addform.orgName"
               style="height: auto;">
      <el-tree :data="orgList"
               :props="defaultProps"
             ref='tree'
               @node-click="handleEditNodeClick"
               class="tree_box"></el-tree>
    </el-option>
  </el-select> -->
                <!-- </el-form-item> -->

                <!-- 模态框表格三餐添加 -->
                <div class="tableData">
                    <el-table
                        :data="tableData"
                        border
                        hight="75px"
                        :class="dialogTile == '查看' ? 'notclick' : ''"
                        :cell-class-name="tableCellClassName"
                        @cell-click="selectMeals"
                    >
                        <el-table-column
                            prop="week"
                            label="日期"
                            width="150"
                            align="right"
                        >
                            <el-table-column
                                prop="meal"
                                label="餐别"
                                width="120"
                            >
                            </el-table-column>
                        </el-table-column>
                        <el-table-column
                            :disabled="dialogTile == '查看'"
                            v-for="(item, index) in weekOptions"
                            :key="index"
                            prop="event"
                            :label="item"
                            align="center"
                        >
                            <template scope="tableData">
                                <div>
                                    {{
                                        myData1[tableData.row.index][
                                            "laebl" + (index + 1)
                                        ]
                                    }}
                                </div>
                                <!-- <div @click="selectMeals(tableData.$index)">{{tableData.row.event }}</div> -->
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!-- 三餐时间选择 -->
                <!--        @change="(val) => timeChange(val,0)"-->
                <el-form-item label="早餐时间">
                    <el-time-picker
                        :disabled="dialogTile == '查看'"
                        v-model="addform.breakfastStartTime"
                        size="mini"
                        @change="dateChangebirthday1"
                        placeholder="请选择开始时间"
                        style="width: 48%"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    ></el-time-picker>
                    至
                    <el-time-picker
                        :disabled="dialogTile == '查看'"
                        v-model="addform.breakfastEndTime"
                        size="mini"
                        @change="dateChangebirthday1"
                        placeholder="请选择结束时间"
                        style="width: 48%"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    ></el-time-picker>
                </el-form-item>
                <el-form-item label="午餐时间">
                    <el-time-picker
                        :disabled="dialogTile == '查看'"
                        v-model="addform.lunchStartTime"
                        size="mini"
                        @change="dateChangebirthday1"
                        placeholder="请选择开始时间"
                        style="width: 48%"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    ></el-time-picker>
                    至
                    <el-time-picker
                        :disabled="dialogTile == '查看'"
                        v-model="addform.lunchEndTime"
                        size="mini"
                        @change="dateChangebirthday1"
                        placeholder="请选择结束时间"
                        style="width: 48%"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    ></el-time-picker>
                </el-form-item>
                <el-form-item label="晚餐时间">
                    <el-time-picker
                        :disabled="dialogTile == '查看'"
                        v-model="addform.dinnerStartTime"
                        size="mini"
                        @change="dateChangebirthday5"
                        placeholder="请选择开始时间"
                        style="width: 48%"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    ></el-time-picker>
                    至
                    <el-time-picker
                        :disabled="dialogTile == '查看'"
                        v-model="addform.dinnerEndTime"
                        size="mini"
                        @change="(val) => timeChange(val, 5)"
                        placeholder="请选择结束时间"
                        style="width: 48%"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @blur="dateChangebirthday6"
                    ></el-time-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" v-if="dialogTile !== '查看'">
                <el-button
                    type="primary"
                    size="small"
                    style="margin: 0 30px"
                    @click="saveadddata"
                    >保存
                </el-button>
                <el-button type="info" size="small" @click="clearadddata"
                    >关闭
                </el-button>
            </div>
        </el-dialog>
        <!-- 模态框中每天三餐菜单表格点击弹出模态框 -->
        <el-dialog
            title="菜品仓库"
            :visible.sync="menuVisible"
            width="990px"
            @close="menuVisibleClose"
        >
            <div class="searchTj">
                <div class="searchTjHead">
                    <span>查询条件</span>
                </div>
                <el-form :model="form1" class="searchTjContent">
                    <div class="searchTjContentDiv" v-if="searchValue1">
                        <span class="searchTjContentDivSpan">菜品名称</span>
                        <el-input
                            placeholder="请输入菜名"
                            v-model="form1.foodName"
                            class="searchTjContentDivInput"
                            clearable
                        >
                        </el-input>
                        <span
                            class="searchTjContentDivSpan"
                            style="margin-left: 20px"
                            >菜品口味</span
                        >
                        <el-select
                            v-model="form1.foodFlavour"
                            placeholder="请选择菜品口味"
                        >
                            <el-option
                                v-for="item in dishesTasteOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div
                        class="searchTjContentDiv"
                        v-show="quanbu"
                        v-if="searchValue1"
                    >
                        <el-button
                            type="primary"
                            icon="el-icon-search"
                            @click="query1"
                            >查询
                        </el-button>
                    </div>

                    <div class="searchTjContentDiv" v-if="searchValue1">
                        <el-button
                            type="info"
                            icon="el-icon-delete"
                            @click="resert1"
                            >清除条件</el-button
                        >
                    </div>
                    <div class="arrowDown" @click="showSearch1">
                        <i class="el-icon-arrow-down" style="color: #000"></i>
                    </div>
                </el-form>
            </div>
            <el-table
                ref="multipleTable1"
                :data="dishesData"
                border
                tooltip-effect="dark"
                @row-click="openDetails1"
                :row-key="getRowunitId"
                style="width: 100%; margin-top: 20px"
                @selection-change="handleSelectionChange1"
                :header-cell-style="{ background: '#F8FAFA', color: '#606266' }"
            >
                <el-table-column
                    type="selection"
                    width="55"
                    :reserve-selection="true"
                >
                    <!--
          @selection-change="handleSelectionChange1" -->
                </el-table-column>
                <el-table-column label="序号" width="120" align="center">
                    <template slot-scope="scope">{{
                        scope.$index + 1
                    }}</template>
                </el-table-column>
                <!-- v-for="(item,index) in dishesTableHeaderOptions" -->
                <el-table-column
                    :key="index"
                    prop="foodName"
                    align="center"
                    label="菜品名称"
                >
                </el-table-column>
                <el-table-column
                    prop="foodDes"
                    label="菜品描述"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="consumableNames"
                    label="菜品材料"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="foodFlavour"
                    label="菜品口味"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.foodFlavour == 0">酸</span>
                        <span v-if="scope.row.foodFlavour == 1">甜</span>
                        <span v-if="scope.row.foodFlavour == 2">苦</span>
                        <span v-if="scope.row.foodFlavour == 3">辣</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="foodPrice"
                    label="菜品价格"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange1"
                @current-change="handleCurrentChange1"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
            <div slot="footer">
                <el-button
                    type="primary"
                    size="small"
                    style="margin: 0 30px"
                    @click="menuSave()"
                    >保存
                </el-button>
                <el-button type="info" size="small" @click="menuClose()"
                    >关闭
                </el-button>
            </div>
        </el-dialog>

        <el-dialog
            title="打印"
            :visible.sync="print1"
            width="980px"
            @close="daYinClose"
        >
            <div style="text-align: center" ref="print">
                <table
                    cellspacing="0"
                    cellpadding="0"
                    style="
                        border-collapse: collapse;
                        text-align: center;
                        margin: auto;
                    "
                >
                    <thead>
                        <tr>
                            <!-- <td colspan="8">{{this.$store.state.info.orgName}}</td> -->
                            <td colspan="8">助餐后台管理</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td id="divider">
                                <span
                                    style="
                                        float: left;
                                        margin-top: 20px;
                                        margin-left: 5px;
                                    "
                                    >餐别</span
                                >
                                <span
                                    class="iconfont icon-vertical_line"
                                ></span>
                                <span
                                    style="float: right; margin-top: -10px;margin-right：10px;"
                                    >日期</span
                                >
                            </td>
                            <td>星期一</td>
                            <td>星期二</td>
                            <td>星期三</td>
                            <td>星期四</td>
                            <td>星期五</td>
                            <td>星期六</td>
                            <td>星期日</td>
                        </tr>
                        <tr>
                            <td>早餐</td>
                            <td>{{ filterData(menuList1, 1, 1) }}</td>
                            <td>{{ filterData(menuList1, 2, 1) }}</td>
                            <td>{{ filterData(menuList1, 3, 1) }}</td>
                            <td>{{ filterData(menuList1, 4, 1) }}</td>
                            <td>{{ filterData(menuList1, 5, 1) }}</td>
                            <td>{{ filterData(menuList1, 6, 1) }}</td>
                            <td>{{ filterData(menuList1, 7, 1) }}</td>
                        </tr>
                        <tr>
                            <td>午餐</td>
                            <td>{{ filterData(menuList1, 1, 2) }}</td>
                            <td>{{ filterData(menuList1, 2, 2) }}</td>
                            <td>{{ filterData(menuList1, 3, 2) }}</td>
                            <td>{{ filterData(menuList1, 4, 2) }}</td>
                            <td>{{ filterData(menuList1, 5, 2) }}</td>
                            <td>{{ filterData(menuList1, 6, 2) }}</td>
                            <td>{{ filterData(menuList1, 7, 2) }}</td>
                        </tr>
                        <tr>
                            <td>晚餐</td>
                            <td>{{ filterData(menuList1, 1, 3) }}</td>
                            <td>{{ filterData(menuList1, 2, 3) }}</td>
                            <td>{{ filterData(menuList1, 3, 3) }}</td>
                            <td>{{ filterData(menuList1, 4, 3) }}</td>
                            <td>{{ filterData(menuList1, 5, 3) }}</td>
                            <td>{{ filterData(menuList1, 6, 3) }}</td>
                            <td>{{ filterData(menuList1, 7, 3) }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="2">
                                早餐时间：{{
                                    menuList1.breakfastStartTime | formatDate1
                                }}至{{
                                    menuList1.breakfastEndTime | formatDate1
                                }}
                            </td>
                            <td colspan="2">
                                午餐时间：{{
                                    menuList1.lunchStartTime | formatDate1
                                }}至{{ menuList1.lunchEndTime | formatDate1 }}
                            </td>
                            <td colspan="2">
                                晚餐时间：{{
                                    menuList1.dinnerStartTime | formatDate1
                                }}至{{ menuList1.dinnerEndTime | formatDate1 }}
                            </td>
                            <td colspan="2">
                                {{ menuList1.startTime }}至{{
                                    menuList1.endTime
                                }}
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div class="boontbtn">
                <el-button
                    type="primary"
                    size="small"
                    style="margin: 0 30px"
                    @click="dy"
                    >打印
                </el-button>
                <el-button type="info" size="small" @click="print1 = false"
                    >取消
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import common from "@/utils/common.js"
import request from "@/utils/request.js"
// import { conflictMediationApi2 } from "@/api/http.js";
// import request2 from "@/utils/request2.js";
import { parseTime } from "@/utils/utils.js"
import { post, get } from "@/api/requrestHttp.js"

export default {
    data() {
        return {
            defaultProps: {
                children: "children",
                label: "label",
            },
            dataTime: "",
            orgLevels: "",
            orgList: [],
            arrOrgList: [],
            addformRules: {
                breakfastStartTime: [
                    { required: true, message: "请选择", trigger: "blur" },
                ],
                lunchStartTime: [
                    { required: true, message: "请选择", trigger: "blur" },
                ],
                dinnerStartTime: [
                    { required: true, message: "请选择", trigger: "blur" },
                ],
                breakfastEndTime: [
                    { required: true, message: "请选择", trigger: "blur" },
                ],
                lunchEndTime: [
                    { required: true, message: "请选择", trigger: "blur" },
                ],
                dinnerEndTime: [
                    { required: true, message: "请选择", trigger: "blur" },
                ],
            },
            multipleSelection1: [],
            start: "",
            end: "",
            tableData: [
                {
                    event: "请添加",
                    meal: "早餐",
                },
                {
                    event: "请添加",
                    meal: "午餐",
                },
                {
                    event: "请添加",
                    meal: "晚餐",
                },
            ],
            currentIndex: "",
            myData2: [],
            myData3: [],
            myData1: [
                {
                    laebl1: "请添加",
                    laebl2: "请添加",
                    laebl3: "请添加",
                    laebl4: "请添加",
                    laebl5: "请添加",
                    laebl6: "请添加",
                    laebl7: "请添加",
                },
                {
                    laebl1: "请添加",
                    laebl2: "请添加",
                    laebl3: "请添加",
                    laebl4: "请添加",
                    laebl5: "请添加",
                    laebl6: "请添加",
                    laebl7: "请添加",
                },
                {
                    laebl1: "请添加",
                    laebl2: "请添加",
                    laebl3: "请添加",
                    laebl4: "请添加",
                    laebl5: "请添加",
                    laebl6: "请添加",
                    laebl7: "请添加",
                },
            ],
            myData20: [
                {
                    laebl1: "请添加",
                    laebl2: "请添加",
                    laebl3: "请添加",
                    laebl4: "请添加",
                    laebl5: "请添加",
                    laebl6: "请添加",
                    laebl7: "请添加",
                },
                {
                    laebl1: "请添加",
                    laebl2: "请添加",
                    laebl3: "请添加",
                    laebl4: "请添加",
                    laebl5: "请添加",
                    laebl6: "请添加",
                    laebl7: "请添加",
                },
                {
                    laebl1: "请添加",
                    laebl2: "请添加",
                    laebl3: "请添加",
                    laebl4: "请添加",
                    laebl5: "请添加",
                    laebl6: "请添加",
                    laebl7: "请添加",
                },
            ],
            print1: false,
            index: "",
            beginDate: {},
            endDate: {},
            item: "",
            showText: true,
            // 图片地址
            actionUrl: "",
            visVisible: false,
            menuVisible: false,
            // 图片
            photo: [],
            addform: {
                qujiId: "",
                shijiid: "",
                shequjiId: "",
                stationId: "",
                shengjiId: "",
                orgId: "",
                orgName: "",
                breakfastStartTime: "",
                breakfastEndTime: "",
                lunchStartTime: "",
                lunchEndTime: "",
                dinnerStartTime: "",
                dinnerEndTime: "",
            },
            checkList: [
                "序号",
                "菜单名称",
                "开始时间",
                "结束时间",
                "创建时间",
                "创建人",
                "操作",
            ],
            // -----------------------------------------------------------------
            // 模态框每周菜单表格表头数据
            weekOptions: [
                "星期一",
                "星期二",
                "星期三",
                "星期四",
                "星期五",
                "星期六",
                "星期日",
            ],
            // -----------------------------------------------------------------
            form1: {},
            // -----------------------------------------------------------------
            mealsTime: ["早餐时间", "午餐时间", "晚餐时间"],
            // -----------------------------------------------------------------
            dishesData: [],
            // -----------------------------------------------------------------
            dishesTasteOptions: [
                {
                    value: "0",
                    label: "酸",
                },
                {
                    value: "1",
                    label: "甜",
                },
                {
                    value: "2",
                    label: "苦",
                },
                {
                    value: "3",
                    label: "辣",
                },
            ],
            value: "",
            // -----------------------------------------------------------------
            quanbu: true,
            currentPage: 1, //默认展示第一页
            total: 0, //总数据
            timer: "", //定义一个定时器的变量
            searchValue: true,
            searchValue1: true,
            editableTabsValue: "1",
            editableTabs: [
                {
                    title: "每周菜单",
                    name: "1",
                },
            ],
            myData: [],
            menuList1: [],
            menuList2: [],
            menuList3: [],
            pageNo: 1,
            pageSize: 10,
            pageConfig: {
                pageSize: 10,
                total: 0,
                pageNo: 1,
            },
            form1: {
                pageNo: 1,
                pageSize: 10,
            },
            form: {},
            dialogTile: "",
            dialogImageUrl: "",
            dialogVisible1: false,
            // 列表显示
            no1: true,
            no2: true,
            no3: true,
            no4: true,
            no5: true,
            no6: true,
            no7: true,
            no8: true,

            saveMenu: "",
            selectedData: [],
            week: "", // 星期暂存
            meal: "", //餐别暂存

            // 时间范围一周 start
            beginDate: {
                disabledDate: (time) => {
                    if (this.endDate != "") {
                        return (
                            time.getTime() < Date.now() - 8.64e7 ||
                            time.getTime() > this.endDate
                        )
                    } else {
                        return time.getTime() < Date.now()
                    }
                },
            },

            endDate: {
                disabledDate: (time) => {
                    return (
                        time.getTime() <
                            new Date(this.addform.startTime).getTime() ||
                        time.getTime() >
                            new Date(this.addform.startTime).getTime() +
                                7 * 24 * 3600 * 1000
                    )
                },
            },
            //时间范围一周 end
        }
    },
    inject: ["reload"], //注入
    filters: {
        //时间格式化
        formatDate1(date) {
            let str = ""
            if (date) {
                let dt = new Date(date)
                let dty = dt.getFullYear()
                let dtm = (dt.getMonth() + 1).toString().padStart(2, "0")
                let dtd = dt.getDate().toString().padStart(2, "0")
                let dth = dt.getHours().toString().padStart(2, "0")
                let dtmi = dt.getMinutes().toString().padStart(2, "0")
                let dts = dt.getSeconds().toString().padStart(2, "0")
                return dth + ":" + dtmi
            }
            return str
        },
        formatDate2(date) {
            let str = " 年 月 日"
            if (date) {
                let dt = new Date(date)
                let dty = dt.getFullYear()
                let dtm = (dt.getMonth() + 1).toString().padStart(2, "0")
                let dtd = dt.getDate().toString().padStart(2, "0")
                let dth = dt.getHours().toString().padStart(2, "0")
                let dtmi = dt.getMinutes().toString().padStart(2, "0")
                let dts = dt.getSeconds().toString().padStart(2, "0")
                return dty + "年" + dtmi + "月" + dtd + "日"
            }
            return str
        },
    },
    methods: {
        dateChangebirthday1() {
            // this.startTime = val;
            if (
                this.addform.breakfastStartTime &&
                this.addform.breakfastEndTime
            ) {
                if (
                    this.addform.breakfastStartTime >
                    this.addform.breakfastEndTime
                ) {
                    this.$message.error("早餐开始时间不得大于结束时间")
                    this.addform.breakfastEndTime = ""
                }
            }
            if (this.addform.breakfastEndTime && this.addform.lunchStartTime) {
                if (
                    this.addform.breakfastEndTime > this.addform.lunchStartTime
                ) {
                    this.$message.error("午餐开始时间不得小于早餐结束时间")
                    this.addform.lunchStartTime = ""
                }
            }
            // console.log(this.addform.lunchStartTime)
            if (this.addform.lunchStartTime && this.addform.lunchEndTime) {
                if (this.addform.lunchStartTime > this.addform.lunchEndTime) {
                    this.$message.error("午餐开始时间不得大于结束时间")
                    this.addform.lunchEndTime = ""
                }
            }
        },
        dateChangebirthday5() {
            if (this.addform.lunchEndTime && this.addform.dinnerStartTime) {
                if (this.addform.dinnerStartTime < this.addform.lunchEndTime) {
                    // console.log(this.addform.dinnerStartTime)
                    this.$message.error("晚餐开始时间不得小于午餐结束时间")
                    this.addform.dinnerStartTime = ""
                }
            }
        },
        dateChangebirthday6() {
            if (this.addform.dinnerStartTime && this.addform.dinnerEndTime) {
                if (this.addform.dinnerStartTime > this.addform.dinnerEndTime) {
                    this.$message.error("晚餐开始时间不得大于结束时间")
                    this.addform.dinnerEndTime = ""
                }
            }
        },
        resert1() {
            // console.log(1212)
            this.form1 = {}
            this.lookList()
        },
        loopNode(node, arr) {
            if (node.parent == null) {
                return arr
            } else {
                arr.push(node.data.orgId)
                this.loopNode(node.parent, arr)
            }
        },
        handleEditNodeClick(data, node) {
            const clickNode = this.$refs.tree.getNode(node)
            const arr = []
            this.loopNode(clickNode, arr)
            this.arrOrgList = arr
            let obj = common.organization(this.arrOrgList, this.orgLevels)
            this.$set(this.addform, "orgId", data.orgId)
            this.$set(this.addform, "parentId", data.parentId)
            this.$set(this.addform, "orgType", data.orgType)
            this.$set(this.addform, "orgName", data.label)

            this.$set(this.addform, "qujiId", obj.qujiId)
            this.$set(this.addform, "shengjiId", obj.shengjiId)
            this.$set(this.addform, "shijiId", obj.shijiId)
            this.$set(this.addform, "stationId", obj.stationId)
            this.$set(this.addform, "shequjiId", obj.shequjiId)
            this.$refs["selectBoxRef"].handleClose()
        },
        //获取组织机构
        getOrg() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/OrgTreelist",
                    method: "POST",
                    data: { isValid: 1 },
                })
                .then((res) => {
                    if (res.code == 200) {
                        for (let i in res.content) {
                            if (res.content[i].orgType == "1") {
                                this.orgList.push(res.content[i])
                            }
                            this.orgLevels = res.content[0].orgLevel
                        }
                    }
                })
        },
        daYinClose() {
            this.print1 = false
            // console.log(1)
        },
        menuVisibleClose1() {
            delete this.addform.id
        },
        menuVisibleClose() {
            this.$refs.multipleTable1.clearSelection()
            // delete this.addform.id;
            // console.log(this.multipleSelection1, "this.multipleSelection1")
        },
        clearSel(row) {
            // console.log(row)
            this.$refs.multipleTable.clearSelection(row)
        },
        showDate() {
            let startTime = this.$day(this.addform.startTime).subtract(
                1,
                "day"
            ).$d
            let endTime = this.$day(startTime).add(7, "day").$d
            // console.log(startTime, endTime)
            this.start = this.splitDate(startTime)
            this.end = this.splitDate(endTime)
            // console.log(this.start, this.end)
        },
        showDates() {
            if (this.dataTime) {
                let startTime = this.$day(this.dataTime).subtract(1, "day").$d
                let endTime = this.$day(startTime).add(7, "day").$d
                this.start = this.splitDate(startTime)
                this.end = this.splitDate(endTime)
            } else {
                this.start = ""
                this.end = ""
            }
        },
        splitDate(time) {
            var date = new Date(time)
            var y = date.getFullYear()
            var m = date.getMonth() + 1
            m = m < 10 ? "0" + m : m
            var d = date.getDate()
            d = d < 10 ? "0" + d : d
            var timeStr = y + "-" + m + "-" + d
            var h = date.getHours()
            h = h < 10 ? "0" + h : h
            var minute = date.getMinutes()
            var second = date.getSeconds()
            minute = minute < 10 ? "0" + minute : minute
            second = second < 10 ? "0" + second : second
            var timeStr =
                y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second
            return timeStr
            // return this.$day(date).format('YYYY-MM-DD')
        },
        filterData(arr, index, meta) {
            let str = ""
            if (arr instanceof Array) {
                arr.forEach((item) => {
                    if (item.week == index && item.meal == meta) {
                        str = item.foodName
                    }
                })
            }
            return str
        },
        timeChange(val, index) {
            // console.log(val)
            let time = parseTime(val.getTime())
            index == 0 && (this.addform.breakfastStartTime = time)
            index == 1 && (this.addform.breakfastEndTime = time)
            index == 2 && (this.addform.lunchStartTime = time)
            index == 3 && (this.addform.lunchEndTime = time)
            index == 4 && (this.addform.dinnerStartTime = time)
            index == 5 && (this.addform.dinnerEndTime = time)
        },

        // 列表项显示
        tableShow() {
            if (this.checkList.length > 0) {
                if (this.checkList.findIndex((obj) => obj == "序号") == -1) {
                    this.no1 = false
                } else {
                    this.no1 = true
                }
                if (
                    this.checkList.findIndex((obj) => obj == "菜单名称") == -1
                ) {
                    this.no2 = false
                } else {
                    this.no2 = true
                }
                if (
                    this.checkList.findIndex((obj) => obj == "开始时间") == -1
                ) {
                    this.no3 = false
                } else {
                    this.no3 = true
                }
                if (
                    this.checkList.findIndex((obj) => obj == "结束时间") == -1
                ) {
                    this.no4 = false
                } else {
                    this.no4 = true
                }
                if (
                    this.checkList.findIndex((obj) => obj == "创建时间") == -1
                ) {
                    this.no5 = false
                } else {
                    this.no5 = true
                }
                if (this.checkList.findIndex((obj) => obj == "创建人") == -1) {
                    this.no6 = false
                } else {
                    this.no6 = true
                }
                if (this.checkList.findIndex((obj) => obj == "操作") == -1) {
                    this.no7 = false
                } else {
                    this.no7 = true
                }
            }
        },

        //时间格式化
        formatDate(row, column) {
            // 获取单元格数据
            let data = row[column.property]
            if (data == null) {
                return null
            }
            let dt = new Date(data)
            let dty = dt.getFullYear()
            let dtm = (dt.getMonth() + 1).toString().padStart(2, "0")
            let dtd = dt.getDate().toString().padStart(2, "0")
            let dth = dt.getHours().toString().padStart(2, "0")
            let dtmi = dt.getMinutes().toString().padStart(2, "0")
            let dts = dt.getSeconds().toString().padStart(2, "0")
            return dty + "-" + dtm + "-" + dtd
        },
        // 打印框
        showPrint(date) {
            this.print1 = true
            post("/sqyl/admin/weeklyMenu/foodListPrint", { id: date.id }).then(
                (res) => {
                    if (res.content == null || res.content == "null") return
                    this.menuList1 = res.content
                    // this.menuList2 = res.content[1];
                    // this.menuList3 = res.content[2];
                    // this.total = res.content.count;
                    // 时间 start
                    if (res.content instanceof Array) {
                        this.menuList1.startTime =
                            res.content[0].startTime.substring(0, 10)
                        this.menuList1.endTime =
                            res.content[0].endTime.substring(0, 10)
                        this.menuList1.breakfastStartTime =
                            res.content[0].breakfastStartTime
                        this.menuList1.breakfastEndTime =
                            res.content[0].breakfastEndTime
                        this.menuList1.lunchStartTime =
                            res.content[0].lunchStartTime
                        this.menuList1.lunchEndTime =
                            res.content[0].lunchEndTime
                        this.menuList1.dinnerStartTime =
                            res.content[0].dinnerStartTime
                        this.menuList1.dinnerEndTime =
                            res.content[0].dinnerEndTime
                        // console.log(this.menuList1.breakfastStartTime)
                    }
                    // 时间 end
                }
            )
        },
        dy() {
            this.$print(this.$refs.print)
        },
        // -----------------------------------------------------------------
        // 新增
        showDialog(type, data) {
            this.visVisible = true
            this.dialogTile = type
            switch (type) {
                case "新增":
                    break
                case "编辑":
                    this.look(data)
                    break
                case "查看":
                    this.look(data)
                    break
            }
        },

        async look(date) {
            // console.log(date)
            // 时间 start
            // console.log(date.startTime, "date.startTime")
            this.addform.startTime = date.startTime
            this.addform.endTime = date.endTime
            this.addform.breakfastStartTime = date.breakfastStartTime
            this.addform.breakfastEndTime = date.breakfastEndTime
            this.addform.lunchStartTime = date.lunchStartTime
            this.addform.lunchEndTime = date.lunchEndTime
            this.addform.dinnerStartTime = date.dinnerStartTime
            this.addform.dinnerEndTime = date.dinnerEndTime
            this.addform.id = date.id
            // 时间 end
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                id: date.id,
            }
            params = Object.assign({}, params)
            await request({
                url: "/sqyl/admin/weeklyMenu/foodListPrint",
                method: "POST",
                data: params,
            }).then((res) => {
                // console.log(res)
                this.start = res.content[0].startTime
                this.end = res.content[0].endTime
                this.addform.breakfastStartTime =
                    res.content[0].breakfastStartTime
                this.addform.breakfastEndTime = res.content[0].breakfastEndTime
                this.addform.lunchStartTime = res.content[0].lunchStartTime
                this.addform.lunchEndTime = res.content[0].lunchEndTime
                this.addform.dinnerStartTime = res.content[0].dinnerStartTime
                this.addform.dinnerEndTime = res.content[0].dinnerEndTime
                this.addform.orgName = res.content[0].orgName

                let tempArr1 = res.content
                let tempArr2 = []
                let arr2 = []
                let arr3 = []
                let arr4 = []
                tempArr1.forEach((item) => {
                    if (item.meal == 1) {
                        arr2.push(item)
                    } else if (item.meal == 2) {
                        arr3.push(item)
                    } else {
                        arr4.push(item)
                    }
                })
                // console.log(arr2,arr3,arr4)
                tempArr2 = [arr2, arr3, arr4]
                // console.log(tempArr2)
                let tempArr = []
                tempArr2.forEach((item, index) => {
                    tempArr[index] = []
                    for (let i = 0; i < 7; i++) {
                        if (item.length == 0) {
                            tempArr[index][i] = {
                                ["laebl" + (i + 1)]: "请添加",
                            }
                        } else {
                            tempArr[index][i] = {}
                            tempArr[index][i]["week"] = i + 1
                            let t = item.filter(
                                (child) =>
                                    tempArr[index][i]["week"] == child.week
                            )
                            if (t.length > 0) {
                                tempArr[index][i] = t[0]
                                tempArr[index][i]["laebl" + (i + 1)] =
                                    t[0]["foodName"]
                            } else {
                                tempArr[index][i] = {
                                    ["laebl" + (i + 1)]: "请添加",
                                }
                            }
                        }
                    }
                })
                let data = []
                tempArr.forEach((item, index) => {
                    data[index] = {}
                    item.forEach((child, i) => {
                        data[index]["laebl" + (i + 1)] =
                            child["laebl" + (i + 1)]
                    })
                })
                this.$set(this, "myData1", data)
                this.$forceUpdate()
                // console.log(this.myData1)
            })
        },
        // 删除
        deleteItem(date) {
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                id: date.id,
            }
            params = Object.assign({}, params)
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                request({
                    url: "/sqyl/admin/weeklyMenu/delete",
                    method: "POST",
                    data: params,
                }).then((res) => {
                    if ((res.code = 200)) {
                        this.showlist()
                    }
                })
            })
        },

        // 行点击选中
        openDetails1(row, event, column, cell) {
            // console.log(this.$refs.multipleTable[0])
            this.$refs.multipleTable[0].toggleRowSelection(row)
            this.row = row
            this.column = column
        },
        getRowunitId(row) {
            // console.log(row)
            return row.id
        },
        handleSelectionChange1(rows) {
            // console.log(rows)
            this.multipleSelection1 = []
            if (rows.length > 0) {
                rows.forEach((item) => {
                    this.multipleSelection1.push(item.id)
                })
            }
        },
        handleSelectionChange(rows) {
            // this.multipleSelection = rows
            this.selectedData = rows
            // console.log(this.selectedData)
        },

        // handleSelectionChange1(data) {
        //     this.selectedData = data;
        // },

        batchDelete() {
            var that = this
            var val = this.selectedData
            if (val.length > 0) {
                this.$confirm("确认永久删除吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        val.forEach(function (item, index) {
                            request({
                                url: "/sqyl/admin/weeklyMenu/delete",
                                method: "POST",
                                data: { id: item.id },
                            })
                        })
                    })
                    .then(() => {
                        this.showlist()
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        })
                    })
            } else {
                this.$confirm("请选择要删除的项。", "提示")
            }
            this.$refs.multipleTable1.clearSelection()
        },
        // -----------------------------------------------------------------
        clearadddata() {
            this.addform = {
                qujiId: "",
                shijiid: "",
                shequjiId: "",
                stationId: "",
                shengjiId: "",
                orgId: "",
                orgName: "",
                breakfastStartTime: "",
                breakfastEndTime: "",
                lunchStartTime: "",
                lunchEndTime: "",
                dinnerStartTime: "",
                dinnerEndTime: "",
            }
            ;(this.myData2 = []),
                (this.myData3 = []),
                (this.myData1 = [
                    {
                        laebl1: "请添加",
                        laebl2: "请添加",
                        laebl3: "请添加",
                        laebl4: "请添加",
                        laebl5: "请添加",
                        laebl6: "请添加",
                        laebl7: "请添加",
                    },
                    {
                        laebl1: "请添加",
                        laebl2: "请添加",
                        laebl3: "请添加",
                        laebl4: "请添加",
                        laebl5: "请添加",
                        laebl6: "请添加",
                        laebl7: "请添加",
                    },
                    {
                        laebl1: "请添加",
                        laebl2: "请添加",
                        laebl3: "请添加",
                        laebl4: "请添加",
                        laebl5: "请添加",
                        laebl6: "请添加",
                        laebl7: "请添加",
                    },
                ]),
                (this.myData20 = [
                    {
                        laebl1: "请添加",
                        laebl2: "请添加",
                        laebl3: "请添加",
                        laebl4: "请添加",
                        laebl5: "请添加",
                        laebl6: "请添加",
                        laebl7: "请添加",
                    },
                    {
                        laebl1: "请添加",
                        laebl2: "请添加",
                        laebl3: "请添加",
                        laebl4: "请添加",
                        laebl5: "请添加",
                        laebl6: "请添加",
                        laebl7: "请添加",
                    },
                    {
                        laebl1: "请添加",
                        laebl2: "请添加",
                        laebl3: "请添加",
                        laebl4: "请添加",
                        laebl5: "请添加",
                        laebl6: "请添加",
                        laebl7: "请添加",
                    },
                ]),
                (this.visVisible = false)
            this.menuVisible = false
        },
        // -----------------------------------------------------------------
        // 保存
        saveadddata(data) {
            this.addform.startTime = this.start
            // this.$refs.formData.validate((valid) => {
            //   if (valid) {
            //     if (this.dialogTile=='新增' || this.dialogTile=='编辑' || this.dialogTile=='审核') {
            //       let url = ''
            //       if(this.addform.lunchEndTime === '' || this.addform.lunchEndTime === null || this.addform.lunchEndTime === undefined) {
            //         this.$message.error('结束时间不能为空')
            //         return
            //       }
            let obj = common.organization(this.arrOrgList, this.orgLevels)
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                // id: this.addform.id,
                ...this.addform,
                userId: this.$store.state.info.id,
                orgName: this.addform.orgName,
                orgId: this.$store.state.info.orgId,
                name: this.$store.state.info.name,
                weeklyMenuList: this.myData3,
                qujiId: obj.qujiId,
                shijiId: obj.shijiId,
                shengjiId: obj.shengjiId,
                stationId: obj.stationId,
                shequjiId: obj.shequjiId,
            }
            params = Object.assign({}, params)
            // console.log(this.dialogTile)
            if (this.dialogTile == "新增") {
                request({
                    url: "/sqyl/admin/weeklyMenu/insert",
                    method: "POST",
                    data: params,
                }).then((res) => {
                    // console.log(res)
                    if (res.code == 200) {
                        this.$message({
                            message: res.message,
                            type: "success",
                        })
                        this.showlist()
                        this.clearadddata()
                    }
                })
            } else {
                request({
                    url: "/sqyl/admin/weeklyMenu/update",
                    method: "POST",
                    data: params,
                }).then((res) => {
                    // console.log(res)
                    if (res.code == 200) {
                        this.showlist()
                        this.visVisible = false
                    }
                })
            }
            //   }
            // }
            // })  // return
        },
        // -----------------------------------------------------------------
        // 模态框表格点击事件
        tableCellClassName({ row, column, rowIndex, columnIndex }) {
            //注意这里是解构
            //利用单元格的 className 的回调方法，给行列索引赋值
            row.index = rowIndex
            column.index = columnIndex
        },

        selectMeals(row, column, cell, event) {
            // console.log(row)
            this.currentIndex = [row.index, "laebl" + column.index]
            if (column.index > 0) {
                this.menuVisible = true
                this.week = column.label
                this.meal = row.meal
                // console.log(this.week,this.eat);
                this.lookList()
            }
        },

        // -----------------------------------------------------------------
        // 模态框菜品仓库表格行内文字溢出显示
        openDetails(row, event, column, cell) {
            // console.log(this.$refs.multipleTable1, "sssssss")
            // this.$refs.multipleTable1.toggleRowSelection(row);
            this.showText = !this.showText
        },
        // -----------------------------------------------------------------
        menuSave() {
            // console.log(JSON.stringify(this.myData1))
            let str = ""
            let menuName = ""
            let menu = ""
            let menu1 = ""
            if (this.$refs.multipleTable1.selection != undefined) {
                if (this.$refs.multipleTable1.selection.length > 0) {
                    menuName = JSON.parse(
                        JSON.stringify(this.$refs.multipleTable1.selection)
                    )
                } else {
                    this.$message.error("请选择菜单")
                    return
                }
            }
            menuName = Array.from(menuName)
            menuName.forEach((e) => {
                str += e.dishesName
            })
            menu1 = menuName.reduce((prve, item) => {
                prve.push(item.foodName)
                return prve
            }, [])
            switch (this.week) {
                case "星期一":
                    this.week = 1
                    break
                case "星期二":
                    this.week = 2
                    break

                case "星期三":
                    this.week = 3
                    break

                case "星期四":
                    this.week = 4
                    break

                case "星期五":
                    this.week = 5
                    break
                case "星期六":
                    this.week = 6
                    break
                case "星期日":
                    this.week = 7
                    break
            }
            switch (this.meal) {
                case "早餐":
                    this.meal = 1
                    break
                case "午餐":
                    this.meal = 2
                    break
                case "晚餐":
                    this.meal = 3
                    break
            }
            menu = menuName.map((item) => {
                return {
                    week: this.week,
                    meal: this.meal,
                    foodName: item.foodName,
                    foodId: item.id,
                    foodPrice: item.foodPrice,
                }
            })
            // let myData2 = [...this.myData1];
            // console.log(
            //     this.myData20[this.currentIndex[0]][this.currentIndex[1]]
            // )
            // console.log(this.myData20)
            this.myData20[this.currentIndex[0]][this.currentIndex[1]] = menu
            let tempArr = []
            this.myData20.forEach((item) => {
                Object.keys(item).forEach((child) => {
                    if (item[child] instanceof Array) {
                        tempArr.push(item[child])
                    }

                    // console.log(item[child])
                })
            })
            // console.log(tempArr)
            // this.currentIndex
            this.myData1[this.currentIndex[0]][this.currentIndex[1]] =
                menu1.join("、")
            // console.log(menu)
            // this.myData2.push(menu[0]);
            if (menu.length > 0) {
                let is = true
                this.myData2.forEach((item) => {
                    //  && item.foodId == menu[0].foodId
                    if (
                        item.week == menu[0].week &&
                        item.meal == menu[0].meal
                    ) {
                        is = false
                    }
                })
                is && this.myData2.push(menu)
            }
            // console.log(this.myData2);

            // this.myData2 = this.myData2.reverse();

            // let newArr = [];
            // let obj = {};
            // let obj1 = {};
            // for (var j=0; j<this.newArr.length;j++) {
            //   for(var i = 0; i < this.myData2.length; i++){
            //     if(this.myData2[i][0].week !== newArr[j][0].week || this.myData2[i][0].meal !== newArr[j][0].meal){
            //       newArr.push(this.myData2[i]);
            //     }
            //   }
            // if (!obj[this.myData2[i][0].week] && !obj1[this.myData2[i][0].meal]) {
            //   newArr.push(this.myData2[i]);
            //   console.log(obj[this.myData2[i][0].week])
            //   obj[this.myData2[i][0].week] = true;
            //   obj1[this.myData2[i][0].meal] = true;
            // }

            // }
            // console.log(obj,obj1)
            // console.log(newArr)
            this.myData3 = tempArr
            this.menuVisible = false
        },
        // -----------------------------------------------------------------
        // 模态框菜品仓库关闭按钮
        menuClose() {
            this.menuVisible = false
        },
        // 每页请求数据
        handleSizeChange(val) {
            this.pageSize = val
            this.showlist()
        },
        // 每页请求数据
        handleSizeChange1(val) {
            this.pageSize = val
            this.lookList()
        },
        // 请求第几数据
        handleCurrentChange(val) {
            this.pageNo = val
            this.showlist()
        },
        // 请求第几数据
        handleCurrentChange1(val) {
            this.pageNo = val
            this.lookList()
        },
        handleClose(key, keyPath) {
            // console.log(key, keyPath)
        },
        handleTabsEdit(targetName, action) {
            this.showlist(e)
        },
        showSearch() {
            this.searchValue = !this.searchValue
        },
        showSearch1() {
            this.searchValue1 = !this.searchValue1
        },
        //拿到列表数据
        async showlist() {
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
            }
            params = Object.assign({}, params)
            await request({
                url: "/sqyl/admin/weeklyMenu/selectAll",
                method: "POST",
                data: params,
            }).then((res) => {
                if (res.content != null) {
                    this.myData = res.content.list
                    this.total = res.content.count
                } else {
                    this.myData = []
                }
            })
        },

        // 查询
        query() {
            post("/sqyl/admin/weeklyMenu/selectAll", {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                ...this.form1,
                startTimeStr: this.start,
                endTimeStr: this.end,
            }).then((res) => {
                // console.log(res)
                if (res.content != null) {
                    this.myData = res.content.list
                    this.total = res.content.count
                } else {
                    this.myData = []
                }
            })
        },
        // 查询
        query1() {
            post("/sqyl/admin/food/info/findList", {
                // post("/admin/weeklyMenu/selectFoodListByCondition", {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                ...this.form1,
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }).then((res) => {
                if (res.content != null) {
                    this.dishesData = res.content.list
                    this.total = res.content.count
                } else {
                    this.dishesData = []
                }
            })
        },

        // 页面刷新
        Reset() {
            this.reload()
        },
        // 新增
        add() {},

        // 预览图片
        handlePicturePreview(file) {
            this.dialogVisible1 = true
            this.dialogImageUrl = file.url
        },
        // 条件查询重置
        resert() {
            this.form1 = {}
            this.showlist()
        },

        // 表单刷新
        resertTable() {
            this.showlist()
            this.checkList = [
                "序号",
                "菜单名称",
                "开始时间",
                "结束时间",
                "创建时间",
                "创建人",
                "操作",
            ]
            this.tableShow()
        },

        // 菜品
        lookList() {
            // this.clearSel()
            post("/sqyl/admin/food/info/findList", {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }).then((res) => {
                // console.log(res)
                this.dishesData = res.content.list
                this.total = res.content.count
            })
        },
    },
    created() {
        // this.getOrg();
        this.showlist()
    },
}
</script>
<style lang='less' scoped>
@import "/iconfont/iconfont.css";
// 模态框按日期查看三餐
.dialogDataPicker {
    width: 100%;
    text-align: right;
    margin-bottom: 10px;
}

// -----------------------------------------------------------------
// 模态框表格
.tableData {
    margin: 0 0 10px 30px;

    /deep/ .el-table thead.is-group th {
        background: none;
    }

    /deep/ .el-table thead.is-group tr:first-of-type th:first-of-type {
        border-bottom: none;
    }

    /deep/ .el-table thead.is-group tr:first-of-type th:first-of-type:before {
        content: "";
        position: absolute;
        width: 1px;
        height: 75px; /*这里需要自己调整，根据td的宽度和高度*/
        top: 0;
        left: 0;
        background-color: grey;
        opacity: 0.3;
        display: block;
        transform: rotate(-51deg); /*这里需要自己调整，根据线的位置*/
        transform-origin: top;
    }

    /deep/ .el-table thead.is-group tr:last-of-type th:first-of-type:before {
        content: "";
        position: absolute;
        width: 1px;
        height: 76px; /*这里需要自己调整，根据td的宽度和高度*/
        bottom: 0;
        right: 0;
        background-color: grey;
        opacity: 0.3;
        display: block;
        transform: rotate(-52deg); /*这里需要自己调整，根据线的位置*/
        transform-origin: bottom;
    }

    /deep/ .el-table--enable-row-transition .el-table__body td {
        text-align: center;
        cursor: pointer;
    }

    /deep/ .el-table--enable-row-transition .el-table__body td:hover {
        cursor: pointer;
        color: #409eff;
    }
}

// -----------------------------------------------------------------
.rkld {
    display: flex;
    flex-direction: row;
    height: 100vh;
    overflow: hidden;
}

.rkldRight {
    flex: 1;
    height: 100%;
    width: calc(100% - 254px);
    background-color: #ffffff;
}

.rkldRightHeadRight {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 15px;
}

.demo-form-inline {
    padding: 0 5%;
}

.btnform {
    text-align: center;
}

.rkldRightHeadRightRight {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    cursor: pointer;
    background: rgba(252, 254, 255, 1);
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 19px;
    box-sizing: border-box;
    padding: 7px 20px;
    margin-left: 20px;
    color: #444;
    font-size: 12px;
}

.rkldRightHeadRightRight span {
    width: 1px;
    height: 20px;
    margin: 0 14px;
    background: #ccc;
    opacity: 0.6;
}

.rkldRightHeadRightRight div {
    display: flex;
    align-items: center;
}

.rkldRightContent {
    height: calc(100% - 70px);
    overflow-y: auto;
    margin: 20px;
}
.searchTj {
    display: flex;
    flex-direction: column;
    position: relative;
    background: #f1f2f6;
    box-shadow: 0 0 6px rgba(151, 151, 151, 0.16);
    overflow: hidden;
    border-radius: 4px;
    margin: 5px;
}

.searchTjHead {
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: rgb(0, 0, 0);
    border-color: rgb(217, 217, 217);
    padding: 6px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
}

.searchTjContent {
    padding: 15px 20px 0px 5px;
    border: 1px solid rgb(217, 217, 217);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.searchTjContentDiv {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 40px;
    margin-bottom: 10px;

    .el-button {
        border-radius: 4px;
    }
}

.searchTjContentDivSpan {
    min-width: 58px;
    margin-right: 20px;
    font-size: 14px;
}

.searchTjContentDivInput {
    width: 20%;
    min-width: 196px;
}

/deep/ .arrowDown {
    width: 28px;
    height: 28px;
    background: #edf2f0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0px);
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
}

/deep/ .el-tabs__content {
    padding-bottom: 20px;
}

.searchButtonDiv {
    height: 54px;
    display: flex;
    margin-top: 14px;
    align-items: center;
    justify-content: space-between;
}

.searchButtonDivLeft {
    display: flex;
}

/deep/ .el-button {
    margin-left: 0px;
    border-radius: 0px;
    padding: 0px 8px !important;
    border: none;
    height: 30px;
}

.el-button-group /deep/ .el-button--warning:last-child {
    border-left-color: rgba(255, 255, 255, 0.5);
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

/deep/ .el-pagination {
    margin-top: 10px;
}

/deep/ .el-submenu__title i {
    color: #fff;
}

/deep/ .el-submenu__title {
    border-bottom: 1px solid #2c3342;
    background: rgb(55, 64, 79) !important;
}

/deep/ .el-submenu.is-active /deep/ .el-submenu__title {
    border-bottom: 1px solid rgb(55, 64, 79);
}

/deep/
    .el-tabs--card
    > .el-tabs__header
    /deep/
    .el-tabs__item.is-active.is-closable {
    color: #0e2d5f;
}

/deep/ .el-submenu {
    width: 234px !important;
}

/deep/ .tabBtn {
    margin: 0px;
}

.boontbtn {
    margin-top: 30px;
    display: flex;
    justify-content: center;
}

.searchButtonDivLeft {
    /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #000000;
    }

    /deep/ .el-button:first-of-type {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    /deep/ .el-button:last-of-type {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;

        i,
        span {
            color: #fff;
        }
    }
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #000000;
}

/* 用来设置当前页面element全局table 选中某行时的背景色*/
/deep/ .el-table__body tr.current-row > td {
    background-color: #fafad2 !important;
    color: #000;
}

/deep/ .el-table tbody tr:hover > td {
    background-color: #fafad2 !important;
}

/deep/ .el-dialog .el-dialog__header {
    border-bottom: 1px solid #e4e4e4;
}

// 弹框底部
/deep/ .el-dialog .el-dialog__footer {
    background-color: #f5f5f5;
}

// 打印
td {
    border: #000000 solid 1px;
    width: 100px;
    height: 100px;
}

/deep/ #divider {
    overflow: hidden;
    position: relative;

    .icon-vertical_line {
        position: absolute;
        left: 0;
        right: 0;
        top: 117px;
        width: 235px;
        height: 1px;
        font-size: 165px;
        transform: rotate(135deg) scaleX(0.1);
    }
}

.notclick {
    pointer-events: none;
}
</style>
